import {
  DocumentData,
  OrderByDirection,
  WhereFilterOp,
  WithFieldValue,
} from "firebase/firestore";
import { AuthUser } from "@constants";

const DEFAULT_USER: AuthUser = {
  firstName: "",
  lastName: "",
  email: "",
  location: "Brown",
  role: "user",
};

export type CollectionQueryComparator = {
  fieldOne: string;
  fieldTwo: string | boolean;
  equalityComparator: WhereFilterOp;
};

export type OrderByConstraint = {
  constraint: "orderBy";
  value: { key: string; direction?: OrderByDirection };
};

export type LimitConstraint = {
  constraint: "limit";
  value: number;
};

export type Constraint = OrderByConstraint | LimitConstraint;

export type DocumentActions = {
  update: <UpdateT extends WithFieldValue<DocumentData>>(
    data: UpdateT,
  ) => Promise<void>;
  delete: () => Promise<void>;
};

export type CollectionActions = {
  update: <UpdateT extends WithFieldValue<DocumentData>>(
    document: DocumentData,
    data: UpdateT,
  ) => Promise<void>;
  delete: (document: DocumentData) => Promise<void>;
};

export type GetCollectionResp<T> = {
  documents: T[] | undefined;
  count: number | undefined;
  helpers: CollectionActions;
};

export const DEFAULT_COLLECTIONS_HOOK_RETURN: GetCollectionResp<never> = {
  documents: undefined,
  count: undefined,
  helpers: {
    update: () => Promise.resolve(),
    delete: () => Promise.resolve(),
  },
};

export { DEFAULT_USER };

export type { AuthUser };
